import classNames from "classnames";
import styles from "./MultipleChoiceAnswerButton.module.css";
import { useCallback, useEffect, useRef, useState } from "react";

interface MultipleChoiceAnswerButtonProps {
  isAnswer: boolean;
  value: string;
  isResultMode: boolean;
  buttonNumber: number;
  onClick: (isAnswer: boolean) => void;
}

export function MultipleChoiceAnswerButton(
  props: MultipleChoiceAnswerButtonProps
) {
  const [isClicked, setIsClicked] = useState(false);

  const handleKeyPress = useCallback(
    (event: KeyboardEvent) => {
      if (
        props.buttonNumber !== undefined &&
        event.key === props.buttonNumber.toString()
      ) {
        handleOnClick();
      }
    },
    [props.buttonNumber, props.onClick]
  );

  // 컴포넌트 마운트 시 키 이벤트 리스너 추가, 언마운트 시 제거
  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  const containerClass = classNames(styles.container, {
    [styles.containerCorrect]: props.isResultMode === true && props.isAnswer,
    [styles.containerIncorrect]:
      props.isResultMode === true && !props.isAnswer && isClicked,
  });

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.style.borderColor = props.isResultMode
        ? ""
        : "var(--border-secondary-color)";
    }
  }, [props.isResultMode]);

  function handleOnClick() {
    if (props.value === undefined || props.isResultMode) {
      return;
    }
    setIsClicked(true);
    props.onClick(props.isAnswer);
  }

  return (
    <>
      <div
        ref={containerRef}
        className={containerClass}
        onClick={() => handleOnClick()}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLDivElement).style.borderColor =
            !props.isResultMode ? "var(--border-secondary-color)" : "";
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLDivElement).style.borderColor = "";
        }}
      >
        <div className={styles.leftContainer}>
          {props.buttonNumber !== undefined && (
            <span className={styles.numberText}>({props.buttonNumber})</span>
          )}
        </div>
        <p className={styles.value}>({props.value})</p>
        <div className={styles.rightContainer}></div>
      </div>
    </>
  );
}
